// HotX Console 0.1.121 首次改密前禁止恢复游客写操作。实际修改时间：2026-09-29 13:25:25 CST；精确父基线：2b265b8475709018e4bf7099ec6a081871eb4c6b；变更：CONSOLE-HOME-DATA-PASSWORD-20260929。
// 仅暂停游客发起的最终写操作；登录成功后恢复原请求，不保存业务表单副本，也不改动各业务流程。

export const GUEST_AUTH_REQUIRED_EVENT = 'hotx:guest-auth-required';

export interface GuestAuthRequestDetail {
  reason: string;
}

interface PendingAuthentication {
  promise: Promise<void>;
  resolve: () => void;
  reject: (error: Error) => void;
}

let authenticationReader: () => boolean = () => false;
let pendingAuthentication: PendingAuthentication | null = null;

export class GuestAuthenticationCancelledError extends Error {
  constructor(message = '已取消登录，当前操作尚未提交。') {
    super(message);
    this.name = 'GuestAuthenticationCancelledError';
  }
}

export function configureConsoleAuthenticationReader(reader: () => boolean) {
  authenticationReader = reader;
}

export function isConsoleAuthenticated() {
  return authenticationReader();
}

export function requireConsoleAuthentication(reason = '登录后继续当前操作') {
  if (isConsoleAuthenticated()) {
    return Promise.resolve();
  }
  if (pendingAuthentication) {
    return pendingAuthentication.promise;
  }

  let resolveAuthentication!: () => void;
  let rejectAuthentication!: (error: Error) => void;
  const promise = new Promise<void>((resolve, reject) => {
    resolveAuthentication = resolve;
    rejectAuthentication = reject;
  });
  const currentRequest: PendingAuthentication = {
    promise,
    resolve: resolveAuthentication,
    reject: rejectAuthentication
  };
  pendingAuthentication = currentRequest;

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent<GuestAuthRequestDetail>(GUEST_AUTH_REQUIRED_EVENT, {
      detail: { reason }
    }));
  }
  return currentRequest.promise;
}

export function completeGuestAuthentication() {
  const currentRequest = pendingAuthentication;
  pendingAuthentication = null;
  currentRequest?.resolve();
}

export function cancelGuestAuthentication(message?: string) {
  const currentRequest = pendingAuthentication;
  pendingAuthentication = null;
  currentRequest?.reject(new GuestAuthenticationCancelledError(message));
}

export function resetGuestAuthenticationGateForTests() {
  pendingAuthentication = null;
  authenticationReader = () => false;
}
